import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { KhodroHttpGetService } from '../Services/KhodroHttpService';

export const getElhaghiyehHayeSadereh = createAsyncThunk('ShakhsSales/getElhaghiyehHayeSadereh', async () => {
  return await KhodroHttpGetService({
    url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.GetElhaghiyehHayeSadereh}`,
  });
});
